
// src/helpers/uploaded-files-changed.js

import shallowEqual from './shallow-equal'

export default function isUploadedFilesChanged(thisUploadedFiles, nextUploadedFiles, mode = 'file_id') {
  var thisKeys = thisUploadedFiles && Object.keys(thisUploadedFiles)
  var nextKeys = nextUploadedFiles && Object.keys(nextUploadedFiles)
  var thisIds = thisUploadedFiles && thisKeys.map((key)=> thisUploadedFiles[key] && thisUploadedFiles[key][mode])
  var nextIds = nextUploadedFiles && nextKeys.map((key)=> nextUploadedFiles[key] && nextUploadedFiles[key][mode])

  if (!shallowEqual(thisKeys, nextKeys) || !shallowEqual(thisIds, nextIds))
    return true
}



// WEBPACK FOOTER //
// ./src/helpers/uploaded-files-changed.js